import React, { useState } from "react";
// import "../Dashboard.css";
import "../KidInfo/Quests.css";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";

export const ParentNotifications = () => {

  const users = ([
    {
      id: 1,
      title: "All Students",
      message: "Exciting News! New Quest Available 🚀",
      date: "10 Dec, 23",
    },
    {
      id: 2,
      title: "All Parents",
      message: "New Quest Unlocked: Historical Adventures 🏰",
      date: "10 Dec, 23",
    },
    {
      id: 3,
      title: "All Teachers",
      message: "Exciting News! New Quest Available 🚀",
      date: "10 Dec, 23",
    },
    {
      id: 4,
      title: "Specific Kids",
      message: "New Quest Unlocked: Historical Adventures 🏰",
      date: "	10 Dec, 23",
    },
    {
      id: 5,
      title: "Specific Kids",
      message: "New Quest Unlocked: Historical Adventures 🏰",
      date: "	10 Dec, 23",
    },
    {
      id: 6,
      title: "All Students",
      message: "New Quest Unlocked: Historical Adventures 🏰",
      date: "	10 Dec, 23",
    },
    {
      id: 7,
      title: "All Teacher",
      message: "New Quest Unlocked: Historical Adventures 🏰",
      date: "	10 Dec, 23",
    },
  ]);

  

  return (
    <>
      <body>
        {/* import sidebar */}
        {/* import sidebar */}

        <div className="container-fluid p-0">
          <div className="p-0" id="mainContent">           
            <div className="teacher-bodycontent mb-4">
              <section>
                <div className="container-fluid">
                  <div className="row mb-4">
                    <div className="col-md-12">
                      <BackButton/>
                    </div>
                    <div className="col-md-6 justify-content-center align-self-center">
                      <p className="tchrdashboard-cmntitl mb-0">
                        Notification Centre
                      </p>
                    </div>
                    <div className="col-md-6 text-end">
                      <Link
                        to="/parent/notification/create"
                        style={{ border: "none", borderRadius: "5px" }}
                        className="text-white mt-4 tchrdashboard-cmnbtn"
                      >
                        Create New
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-hover tchrtabl-pdng">
                          <thead className="quest-tablehead">
                            <tr>
                              <th scope="col">Title</th>
                              <th scope="col">Message</th>
                              <th scope="col">Date</th>

                              {/* <th scope="col" className="text-center">
                                Action
                              </th> */}
                            </tr>
                          </thead>
                          <tbody className="tchrtablbody">
                            {users.map((user) => {
                              return (
                                <tr key={user.id}>
                                  <td>{user.title}</td>
                                  <td>{user.message}</td>
                                  <td>{user.date}</td>

                                  {/* <td className="text-center">
                                    <a href="">
                                      <i
                                        style={{ color: "#424242" }}
                                        className="fa-regular fa-eye"
                                      ></i>
                                    </a>
                                    <a
                                      className="tchrdashboard-tableicn"
                                      href=""
                                    >
                                      <img src="https://d2lvj32mp5x83n.cloudfront.net/static/superadmin/icons/edit.png" alt="" />
                                    </a>
                                    <a
                                      className="tchrdashboard-edittableicn"
                                      href=""
                                    >
                                      <img src={deleteicon} alt="" />
                                    </a>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};
